import { StateStream } from '@cgs/wge';

export class BaseStore<T> {
  protected _stream: StateStream<T>;

  constructor(initialState: T) {
    this._stream = new StateStream<T>(initialState);
  }

  public get stream(): StateStream<T> {
    return this._stream;
  }

  public get state(): T {
    return this._stream.state;
  }

  public set state(data: T) {
    this._stream.emit(data);
  }

  public get prevState(): T | null {
    return this._stream.prevState;
  }

  public update(partial: Partial<T>): void {
    this.state = { ...this.state, ...partial };
  }
}
